// This file is autogenerated. Any changes will be overwritten.
export const name = 'dock';

export const Component = () => (
  <path d='m11.5 13.5v7.5c0 .5522847-.4477153 1-1 1-.55228475 0-1-.4477153-1-1l-.00089322-4.0858932-6.08489322 6.0858932c-.39052429.3905243-1.02368927.3905243-1.41421356 0s-.39052429-1.0236893 0-1.4142136l6.08610678-6.0866796-4.08610678.0008932c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1zm11.5-11.5c.3905243.39052429.3905243 1.02368927 0 1.41421356l-6.1198932 6.11889322 4.153477.00047705c.5522848 0 1 .44771525 1 .99999997 0 .5522848-.4477152 1-1 1h-7.5v-7.5335838c0-.55228475.4477153-1 1-1 .5522848 0 1 .44771525 1 1l-.000477 4.05210678 6.0526796-6.05210678c.3905243-.39052429 1.0236893-.39052429 1.4142136 0z' />
);

export const viewBox = '0 0 25 25';
